export const FEATURES = {
  types: {
    /**
     * TODO get the name directly from translation files for the header
     */

    directMessaging: {
      id: 'DIRECT_MESSAGING',
      header: 'In-App Messaging',
    },
    departments: {
      id: 'DEPARTMENTS',
      header: 'Department',
    },
    attendance: {
      id: 'ATTENDANCE_TRACKING',
      header: 'Attendance Tracking',
    },
    emergency: { id: 'EMERGENCY', header: 'Emergencies' },
  },
  service: {
    notification: 'NOTIFICATION',
    distress: 'DISTRESS',
    patrol: 'PATROL',
    transport: 'TRANSPORT',
    events: 'EVENTS',
    users: 'USERS',
    assets: 'ASSETS',
    region: 'REGION',
    task: 'TASK',
    media: 'MEDIA',
  },
};
